const nav91 = document.querySelector('.nav91');
const toggleNav91 = document.querySelector('.toggle-nav91');
const overlay91 = document.querySelector('.overlay91');
const closeNav91 = document.querySelector('.nav91-close');
const navLinks = document.querySelectorAll('a.site-nav__link.site-nav__link--has-dropdown');

toggleNav91.addEventListener('click', () => {
  nav91.classList.toggle('open');
  overlay91.classList.toggle('open');
  updateNavLinkStyles();
});

overlay91.addEventListener('click', () => {
  nav91.classList.remove('open');
  overlay91.classList.remove('open');
  updateNavLinkStyles();
});

closeNav91.addEventListener('click', () => {
  nav91.classList.remove('open');
  overlay91.classList.remove('open');
  updateNavLinkStyles();
});

function updateNavLinkStyles() {
  const isNavOpen = nav91.classList.contains('open');
  navLinks.forEach(link => {
    link.style.color = isNavOpen ? 'gray' : ''; // Reset to default color when drawer is closed
  });
}